import type { PartyMemberEligibility } from "@bw/shared/types/generated";

export const PARTY_MEMBER_STATE_LABELS: Record<
  PartyMemberEligibility["state"],
  string
> = {
  eligible: "Eligible",
  needs_action: "Needs action",
  waiting: "Waiting",
  on_court: "On court",
  unavailable: "Unavailable",
};

export const PARTY_MEMBER_REASON_LABELS: Record<
  PartyMemberEligibility["reason"],
  string
> = {
  eligible: "Ready to play",
  check_in_required: "Check-in required",
  staff_validation_required: "Staff validation required",
  session_expired: "Session expired",
  session_too_short: "Session ends too soon",
  already_waiting: "Already waiting",
  already_on_court: "Already on court",
  eligibility_unavailable: "Status unavailable",
};

export const PARTY_MEMBER_ACTIVITY_LABELS: Record<
  PartyMemberEligibility["activity_state"],
  string
> = {
  none: "Activity pending",
  waiting: "Waiting",
  on_court: "On court",
};

export const PARTY_MEMBER_ADMISSION_LABELS: Record<
  PartyMemberEligibility["admission_state"],
  string
> = {
  active: "Checked in",
  pending_validation: "Staff check-in needed",
  inactive: "Session expired",
  none: "Check-in required",
  unavailable: "Check-in unavailable",
};

export function safePartyMemberName(
  member: PartyMemberEligibility,
  index: number,
): string {
  const name = member.display_name?.trim();
  return !name || name === member.member_id.trim()
    ? `Player ${index + 1}`
    : name;
}
